import { GetHeader, PPHeader, DeleteHeader } from "../common"

const URL = process.env.REACT_APP_API_MIKEIYAKU!

export interface typeUncontract {
  userCd: string,
  termCd: string | null,
  startDate: string | null,
  endDate: string | null,
  telephoneNumber: string | null,
  mobileNumber: string | null,
  faxNumber: string | null,
  extensionNumber: string | null,
  extensionFaxNumber: string | null,
  countryCd: string | null,
  zipCode: string | null,
  emailAddress1: string | null,
  emailAddress2: string | null,
  mobileEmailAddress: string | null,
  url: string | null,
  localeId: string | null,
  userName: string,
  userNameSyllabary: string,
  userNameEng: string | null,
  address: string | null,
  companyCd: string,
  departmentCd: string | null,
  departmentName: string | null,
  departmentNameSyllabary: string | null,
  departmentNameEng: string | null,
  address1: string | null,
  address2: string | null,
  notes: string | null,
}

export interface typeputUncontract {
  userName: string,
  userNameSyllabary: string,
}

//033 未契約顧客一覧
export const getUncontractList = async (userid: string, token: string, role: string, keyword: string): Promise<typeUncontract[]> => {
  const params = new URLSearchParams()
  params.set('keyWord', keyword)
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/mikeiyakus?${params.toString()}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//042 未契約顧客登録
export const postUncontract = async (userid: string, token: string, role: string, form: typeputUncontract): Promise<boolean> => {
  //form to JSON
  const jsondata = JSON.stringify(form)
  const header = PPHeader(userid, token, role, jsondata, 'POST')
  const res = await fetch(`${URL}/mikeiyaku`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//043 未契約顧客取得
export const getUncontract = async (userid: string, token: string, role: string, usercd: string): Promise<typeUncontract> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/mikeiyaku/${usercd}`, header).then(response => {
    if (response.status === 204) {
      return null
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}


//044 未契約顧客更新
export const putUncontract = async (userid: string, token: string, role: string, usercd: string, form: typeputUncontract) => {
  //form to JSON
  const jsondata = JSON.stringify(form)
  const header = PPHeader(userid, token, role, jsondata, 'PUT')
  const res = await fetch(`${URL}/mikeiyaku/${usercd}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//045 未契約顧客削除
export const deleteUncontract = async (userid: string, token: string, role: string, usercd: string): Promise<boolean> => {
  const header = DeleteHeader(userid, token, role)
  const res = await fetch(`${URL}/mikeiyaku/${usercd}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}